import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { useMenuItemStore } from "store/menuItem";
import { findMenuItemByPath } from "utils/helper";
import { getPageAccessApi } from "api/menu";
import { PageAccessByMenu } from "interface/user";

// add doc
/**
 * Custom hook to manage page access and home page access.
 * It fetches the access rights for the current page and the home page items.
 * Note: homePageAccess  should be used only for the home page  path  "/",
 * @returns {Object} - Contains pageAccess, homePageAccess, and loading state.
 */
export const usePageAccess = () => {
	const [pageAccess, setPageAccess] = useState<PageAccessByMenu | null>(null);
	// const [homePageAccess, setHomePageAccess] = useState<homePageAccess | null>(
	// 	null,
	// );

	const [loading, setLoading] = useState(true);
	const location = useLocation();
	const { menuItems } = useMenuItemStore();
	const currentPath = location.pathname;

	useEffect(() => {
		const pageHandler = async () => {
			const menu = findMenuItemByPath(menuItems, currentPath);
			try {
				if (menu) {
					const access = await getPageAccessApi(menu.id);
					setPageAccess(access);
				}
				// if (isLoadingRef.current) return;
				// isLoadingRef.current = true;

				// // if (currentPath === "/" && homePageAccess === null) {
				// if (currentPath === "/" && homePageAccess === null) {
				// 	const homeAccess = await getHomePageItemAccessApi();
				// 	const registrationAccess = homeAccess.find(
				// 		(item) => item.path === PageTypePath.RegistrationList,
				// 	);
				// 	const salesNoteAccess = homeAccess.find(
				// 		(item) => item.path === PageTypePath.SalesNotesList,
				// 	);
				// 	const landingNoteAccess = homeAccess.find(
				// 		(item) => item.path === PageTypePath.LandingNoteList,
				// 	);

				// 	setHomePageAccess({
				// 		registration: registrationAccess,
				// 		salesNote: salesNoteAccess,
				// 		landingNote: landingNoteAccess,
				// 	});
				// }
			} catch (error) {
				console.error("Error fetching page access:", error);
			} finally {
				setLoading(false);
				// isLoadingRef.current = false;
			}
		};
		pageHandler();
	}, [currentPath, menuItems]);

	return { pageAccess, loading };
};
